import { useEffect, useState } from "react";

import PageHeader from "../components/PageHeader.jsx";
import apiClient from "../services/api.js";

const buildFormState = () => ({
  title: "",
  description: "",
  goal_amount: "",
  expires_at: ""
});

export default function CrowdfundingPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [form, setForm] = useState(() => buildFormState());

  useEffect(() => {
    apiClient
      .get("/crowdfunding/campaigns")
      .then((response) => setCampaigns(response.data))
      .catch(() => setCampaigns([]));
  }, []);

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { data } = await apiClient.post("/crowdfunding/campaigns", {
      ...form,
      goal_amount: Number(form.goal_amount)
    });
    setCampaigns((prev) => [data, ...prev]);
    setForm(buildFormState());
  };

  return (
    <div className="space-y-8">
      <PageHeader
        title="Crowdfunding"
        description="Launch transparent community campaigns for urgent causes."
      />
      <form onSubmit={handleSubmit} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-4">
        <input
          name="title"
          value={form.title}
          onChange={handleChange}
          placeholder="Campaign title"
          required
          className="w-full rounded-lg border border-slate-300 px-3 py-2"
        />
        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Describe the purpose"
          required
          rows={3}
          className="w-full rounded-lg border border-slate-300 px-3 py-2"
        />
        <div className="grid gap-4 md:grid-cols-2">
          <input
            name="goal_amount"
            type="number"
            min="0"
            step="0.01"
            value={form.goal_amount}
            onChange={handleChange}
            placeholder="Goal amount"
            required
            className="rounded-lg border border-slate-300 px-3 py-2"
          />
          <input
            name="expires_at"
            type="date"
            value={form.expires_at}
            onChange={handleChange}
            required
            className="rounded-lg border border-slate-300 px-3 py-2"
          />
        </div>
        <button type="submit" className="rounded-lg bg-accent px-4 py-2 font-semibold text-white hover:bg-accent/80">
          Publish Campaign
        </button>
      </form>
      <div className="grid gap-4 md:grid-cols-2">
        {campaigns.map((campaign) => (
          <article key={campaign.id} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <p className="text-xs uppercase tracking-wider text-slate-400">{campaign.status}</p>
            <h3 className="mt-2 text-lg font-semibold">{campaign.title}</h3>
            <p className="text-sm text-slate-500">{campaign.description}</p>
            <div className="mt-4 flex items-center justify-between text-sm">
              <span className="font-semibold text-accent">NGN {campaign.amount_raised}</span>
              <span className="text-slate-400">of NGN {campaign.goal_amount}</span>
            </div>
          </article>
        ))}
        {!campaigns.length && <p className="text-sm text-slate-500">No campaigns published yet.</p>}
      </div>
    </div>
  );
}
